export const countryMapper: { [key: string]: string } = {
  'en-gb': 'UK',
  'en-us': 'US',
  'en-ie': 'Ireland',
  'en-ca': 'Canada',
  'fr-ca': 'Canada',
  'en-vg': 'UK',
};
